<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title pull-left">{{ modalTitle }}</h5>
                <button
                  type="button"
                  class="close pull-right"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span
                    class="theX pull-right"
                    aria-hidden="true"
                    @click="setModalState(false)"
                  >
                    &times;
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
  },
  computed: {
    modalTitle() {
      return this.$store.state.dic.modal_title;
    },
  },
  methods: {
    setModalState(modalState) {
      this.$store.dispatch("setModalState", modalState);
    },
  },
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
